
    const original = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"17.3819\" height=\"18.10424\" viewBox=\"0,0,17.3819,18.10424\"><g transform=\"translate(-233.20839,-171.20203)\"><g fill=\"#855cd6\" stroke=\"#855cd6\" stroke-miterlimit=\"10\"><path d=\"M249.50761,180.6465l-15.79922,7.8529v-16.45579z\"/></g></g></svg><!--rotationCenter:6.7916099999999915:8.797965477592726-->";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
